import axiosInstance from "@/utils/axios";
import API from "@/constant/API";
import { setToken } from "@/redux/slices/user";

const login = async (data) => {
  return await axiosInstance.post(API.LOGIN, data);
}


const logout = async () => {
  return await axiosInstance.post(API.LOGOUT);
}

const checkRegisterAccount = async (data) => {
  return await axiosInstance.post(API.REGISTER_CHECK_ACCOUNT, data);
}

const register = async (token, data) => {
  return await axiosInstance.post(API.REGISTER, data, {
    headers: {
      'X-Token': token,
    }
  });
}

const sendEmailCode = async (data) => {
  return await axiosInstance.post(API.EMAIL_VERIFY_RESEND, data);
}
const sendPhoneCode = async (data) => {
  return await axiosInstance.post(API.MOBILE_VERIFY_RESEND, data);
}

const sendCodeChannel = async (data) => {
  return await axiosInstance.post(API.SEND_CODE_CHANNEL, data);
}

const checkLoginAccount = async (data) => {
  return await axiosInstance.post(API.LOGIN_CHECK_ACCOUNT, data);
}

const findPw = async (data) => {
  return await axiosInstance.post(API.PW_FIND, data);
}

const updatePw = async (data) => {
  return await axiosInstance.post(API.PW_UPDATE, data);
}

const setPw = async (data) => {
  return await axiosInstance.post(API.PW_SET, data);
}

const checkFindPwAccount = async (data) => {
  return await axiosInstance.post(API.PW_FIND_ACCOUNT_EXIST, data);
}

const authLogin = async (data) => {
  return await axiosInstance.post(API.USER_AUTH_LOGIN, data);
}

const userHome = async () => {
  return await axiosInstance.post(API.USER_HOME);
}

const getDepositInitInfo = async (data) => {
  return await axiosInstance.post(API.DEPOSIT_INIT, data);
}

const getAddressList = async (data) => {
  return await axiosInstance.post(API.WITHDRAW_ADDRESS_LIST, data);
}

const getWithdrawInitInfo = async (data) => {
  return await axiosInstance.post(API.WITHDRAW_INIT, data);
}

const addWithdrawAddress = async (data) => {
  return await axiosInstance.post(API.WITHDRAW_ADDRESS_ADD, data);
}

const withdrawApply = async (data) => {
  return await axiosInstance.post(API.WITHDRAW_APPLY, data)
}

const getWithdrawDetail = async (data) => {
  return await axiosInstance.post(API.WITHDRAW_DETAIL, data)
}

const deleteWithdrawAddress = async (data) => {
  return await axiosInstance.post(API.WITHDRAW_ADDRESS_DEL, data)
}

export {
  login,
  logout,
  checkRegisterAccount,
  register,
  sendEmailCode,
  sendPhoneCode,
  sendCodeChannel,
  checkLoginAccount,
  findPw,
  updatePw,
  setPw,
  checkFindPwAccount,
  authLogin,

  userHome,
  getDepositInitInfo,
  getAddressList,
  getWithdrawInitInfo,
  withdrawApply,
  getWithdrawDetail,

  addWithdrawAddress,
  deleteWithdrawAddress
};
